import React from "react";
import "./Popup.css";

const Popup = ({ children, onClose }) => {
  return (
    <div className="popup" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="close-button" onClick={onClose}>X</div>
        {children}
      </div>
    </div>
  );
};

export default Popup;
